import gql from "graphql-tag";

export const focusGroupQuery = gql`
  query features {
    features {
      id
      name
      code
      isActive
      customers {
        id
        name
      }
    }
  }
`;
